import React, { createContext, useContext, useState, useCallback } from 'react';

const TaskContext = createContext();

export const useTasks = () => {
    const context = useContext(TaskContext);
    if (!context) {
        throw new Error('useTasks must be used within a TaskProvider');
    }
    return context;
};

export const TaskProvider = ({ children }) => {
    const [tasks, setTasks] = useState([]);
    const [isPanelOpen, setIsPanelOpen] = useState(true);
    const [activeTaskId, setActiveTaskId] = useState(null);
    const [activeTab, setActiveTab] = useState('logs');

    const addTask = useCallback((title) => {
        const id = Date.now().toString();
        const newTask = {
            id,
            title,
            logs: '',
            status: 'running',
            startTime: new Date(),
        };
        setTasks(prev => [newTask, ...prev].slice(0, 50)); // Keep last 50 tasks
        setActiveTaskId(id);
        setActiveTab('logs');
        setIsPanelOpen(true);
        return id;
    }, []);

    const updateTaskLogs = useCallback((id, chunk) => {
        setTasks(prev => prev.map(task =>
            task.id === id ? { ...task, logs: task.logs + chunk } : task
        ));
    }, []);

    const finishTask = useCallback((id, success = true) => {
        setTasks(prev => prev.map(task =>
            task.id === id ? { ...task, status: success ? 'success' : 'error' } : task
        ));
    }, []);

    const clearTasks = useCallback(() => {
        setTasks([]);
        setActiveTaskId(null);
    }, []);

    const value = {
        tasks,
        activeTaskId,
        setActiveTaskId,
        isPanelOpen,
        setIsPanelOpen,
        activeTab,
        setActiveTab,
        addTask,
        updateTaskLogs,
        finishTask,
        clearTasks
    };

    return (
        <TaskContext.Provider value={value}>
            {children}
        </TaskContext.Provider>
    );
};
